var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSucessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90005 12.4578L11.7 16.4578L18.774 7.42924M12.5 23.6578C11.0292 23.6578 9.57284 23.3681 8.21399 22.8053C6.85515 22.2424 5.62047 21.4174 4.58045 20.3774C3.54044 19.3374 2.71545 18.1027 2.1526 16.7439C1.58975 15.385 1.30005 13.9286 1.30005 12.4578C1.30005 10.987 1.58975 9.5306 2.1526 8.17176C2.71545 6.81291 3.54044 5.57823 4.58045 4.53822C5.62047 3.4982 6.85515 2.67321 8.21399 2.11036C9.57284 1.54751 11.0292 1.25781 12.5 1.25781C15.4705 1.25781 18.3192 2.43781 20.4196 4.53822C22.5201 6.63862 23.7 9.48739 23.7 12.4578C23.7 15.4282 22.5201 18.277 20.4196 20.3774C18.3192 22.4778 15.4705 23.6578 12.5 23.6578Z",
    stroke: "#45494F",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessIcon);
export default __webpack_public_path__ + "static/media/sucess-icon.aed9801e.svg";
export { ForwardRef as ReactComponent };